import { render, staticRenderFns } from "./Groups.vue?vue&type=template&id=0a46e434&scoped=true"
import script from "./Groups.vue?vue&type=script&lang=ts"
export * from "./Groups.vue?vue&type=script&lang=ts"
import style0 from "./Groups.vue?vue&type=style&index=0&id=0a46e434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a46e434",
  null
  
)

export default component.exports